"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScript = exports.generateUUID = exports.allSettled = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/**
 * Promise.allSettled的polyfill函数
 * @param {Array} promises Promise对象集合
 */
var allSettled = exports.allSettled = function allSettled(promises) {
  var wrappedPromises = promises.map(function (p) {
    return Promise.resolve(p).then(function (val) {
      return {
        status: 'fulfilled',
        value: val
      };
    }, function (err) {
      return {
        status: 'rejected',
        reason: err
      };
    });
  });
  return Promise.all(wrappedPromises);
};

/**
 * 构造一个script标签并下载js文件
 * @param {*} scriptUrl js文件的地址
 */
var loadScript = exports.loadScript = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(scriptUrl) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.onload = function () {
              resolve(script);
            };
            script.onerror = function (e) {
              reject(e);
            };
            script.src = "".concat(scriptUrl, "?max_age=5184000");
            document.body.appendChild(script);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadScript(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取uuid随机数
 * @param {*} count 长度
 * @param {*} raDix 随机取值范围
 */
var _char = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
var generateUUID = exports.generateUUID = function generateUUID() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var raDix = arguments.length > 1 ? arguments[1] : undefined;
  var uuid = [];
  var curRaDix = raDix || _char.length;
  if (count) {
    for (var i = 0; i < count; i++) uuid[i] = _char[0 | Math.random() * curRaDix];
  } else {
    var rfc;
    uuid[8] = '-';
    uuid[13] = '-';
    uuid[18] = '-';
    uuid[23] = '-';
    uuid[14] = '4';
    for (var _i = 0; _i < 36; _i++) {
      if (!uuid[_i]) {
        rfc = 0 | Math.random() * 16;
        uuid[_i] = _char[_i === 19 ? rfc & 0x3 | 0x8 : rfc];
      }
    }
  }
  return uuid.join('');
};